import React from 'react';
import { CampoNumeroBase } from './CampoValor';

/**
 * Percentual pt-BR: sem milhar, "." e "," valem como decimal, sufixo "%" fora
 * do foco, mesmo modelo de digitação/colagem do CampoValor ("19.05" / "19,05" /
 * "19,05%" → 19,05). Mantenha o `decimalScale` que o campo já usava (4 casas no
 * serviço/impostos da planilha, 2 no Imposto NF). `sufixo=""` em célula estreita
 * cujo cabeçalho já diz "%". Sem casas fixas, mostra só as casas que existem.
 */
export default function CampoPercentual({ sufixo = '%', casasMinimas = 0, ...props }) {
    return <CampoNumeroBase milhar={false} suffix={sufixo || ''} casasMinimas={casasMinimas} {...props} />;
}

export { CampoPercentual };
